// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/registration/kyc/firstparty/v2/create_kyc.proto

/* oxlint-disable */

/** The KYC provider handling the verification. */
export const ApiProvider = {
  /** PROVIDER_UNSPECIFIED - Unspecified provider (for forward compatibility). */
  PROVIDER_UNSPECIFIED: "PROVIDER_UNSPECIFIED",
  /**
   * IDNow video identification provider.
   */
  idnow_videoident: "idnow_videoident",
  /**
   * Fourthline KYC provider.
   */
  fourthline: "fourthline",
  /**
   * Onfido identity verification provider.
   */
  onfido: "onfido",
  /**
   * Qonto internal KYC provider.
   */
  qonto: "qonto",
  /**
   * INPI (Institut National de la Propriété Industrielle) provider.
   */
  inpi: "inpi",
} as const;

export type ApiProvider = typeof ApiProvider[keyof typeof ApiProvider];

export namespace ApiProvider {
  export type PROVIDER_UNSPECIFIED = typeof ApiProvider.PROVIDER_UNSPECIFIED;
  export type idnow_videoident = typeof ApiProvider.idnow_videoident;
  export type fourthline = typeof ApiProvider.fourthline;
  export type onfido = typeof ApiProvider.onfido;
  export type qonto = typeof ApiProvider.qonto;
  export type inpi = typeof ApiProvider.inpi;
}

export function apiProviderFromJSON(object: any): ApiProvider {
  switch (object) {
    case 0:
    case "PROVIDER_UNSPECIFIED":
      return ApiProvider.PROVIDER_UNSPECIFIED;
    case 1:
    case "idnow_videoident":
      return ApiProvider.idnow_videoident;
    case 2:
    case "fourthline":
      return ApiProvider.fourthline;
    case 3:
    case "onfido":
      return ApiProvider.onfido;
    case 4:
    case "qonto":
      return ApiProvider.qonto;
    case 5:
    case "inpi":
      return ApiProvider.inpi;
    default:
      return ApiProvider.PROVIDER_UNSPECIFIED;
  }
}

export function apiProviderToJSON(object: ApiProvider): string {
  switch (object) {
    case ApiProvider.PROVIDER_UNSPECIFIED:
      return "PROVIDER_UNSPECIFIED";
    case ApiProvider.idnow_videoident:
      return "idnow_videoident";
    case ApiProvider.fourthline:
      return "fourthline";
    case ApiProvider.onfido:
      return "onfido";
    case ApiProvider.qonto:
      return "qonto";
    case ApiProvider.inpi:
      return "inpi";
    default:
      return "PROVIDER_UNSPECIFIED";
  }
}

/**
 * The status of the KYC verification process.
 * Values depend on the provider: IDNow uses on_call/succeeded/waiting_results/rejected/canceled/failed/pending;
 * Fourthline uses kyc_required/qes_required/process_finished.
 */
export const ApiProviderStatus = {
  /** PROVIDER_STATUS_UNSPECIFIED - Unspecified status (for forward compatibility). */
  PROVIDER_STATUS_UNSPECIFIED: "PROVIDER_STATUS_UNSPECIFIED",
  /**
   * Verification is pending and has not yet started.
   */
  pending: "pending",
  /**
   * Verification call is in progress (IDNow).
   */
  on_call: "on_call",
  /**
   * Verification completed successfully (IDNow).
   */
  succeeded: "succeeded",
  /**
   * Verification failed (IDNow).
   */
  failed: "failed",
  /**
   * Verification was canceled by the user (IDNow).
   */
  canceled: "canceled",
  /**
   * Verification completed, awaiting results (IDNow).
   */
  waiting_results: "waiting_results",
  /**
   * Verification was rejected (IDNow).
   */
  rejected: "rejected",
  /**
   * KYC verification is required (Fourthline).
   */
  kyc_required: "kyc_required",
  /**
   * QES (Qualified Electronic Signature) is required (Fourthline).
   */
  qes_required: "qes_required",
  /**
   * KYC process has finished (Fourthline).
   */
  process_finished: "process_finished",
} as const;

export type ApiProviderStatus = typeof ApiProviderStatus[keyof typeof ApiProviderStatus];

export namespace ApiProviderStatus {
  export type PROVIDER_STATUS_UNSPECIFIED = typeof ApiProviderStatus.PROVIDER_STATUS_UNSPECIFIED;
  export type pending = typeof ApiProviderStatus.pending;
  export type on_call = typeof ApiProviderStatus.on_call;
  export type succeeded = typeof ApiProviderStatus.succeeded;
  export type failed = typeof ApiProviderStatus.failed;
  export type canceled = typeof ApiProviderStatus.canceled;
  export type waiting_results = typeof ApiProviderStatus.waiting_results;
  export type rejected = typeof ApiProviderStatus.rejected;
  export type kyc_required = typeof ApiProviderStatus.kyc_required;
  export type qes_required = typeof ApiProviderStatus.qes_required;
  export type process_finished = typeof ApiProviderStatus.process_finished;
}

export function apiProviderStatusFromJSON(object: any): ApiProviderStatus {
  switch (object) {
    case 0:
    case "PROVIDER_STATUS_UNSPECIFIED":
      return ApiProviderStatus.PROVIDER_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiProviderStatus.pending;
    case 2:
    case "on_call":
      return ApiProviderStatus.on_call;
    case 3:
    case "succeeded":
      return ApiProviderStatus.succeeded;
    case 4:
    case "failed":
      return ApiProviderStatus.failed;
    case 5:
    case "canceled":
      return ApiProviderStatus.canceled;
    case 6:
    case "waiting_results":
      return ApiProviderStatus.waiting_results;
    case 7:
    case "rejected":
      return ApiProviderStatus.rejected;
    case 8:
    case "kyc_required":
      return ApiProviderStatus.kyc_required;
    case 9:
    case "qes_required":
      return ApiProviderStatus.qes_required;
    case 10:
    case "process_finished":
      return ApiProviderStatus.process_finished;
    default:
      return ApiProviderStatus.PROVIDER_STATUS_UNSPECIFIED;
  }
}

export function apiProviderStatusToJSON(object: ApiProviderStatus): string {
  switch (object) {
    case ApiProviderStatus.PROVIDER_STATUS_UNSPECIFIED:
      return "PROVIDER_STATUS_UNSPECIFIED";
    case ApiProviderStatus.pending:
      return "pending";
    case ApiProviderStatus.on_call:
      return "on_call";
    case ApiProviderStatus.succeeded:
      return "succeeded";
    case ApiProviderStatus.failed:
      return "failed";
    case ApiProviderStatus.canceled:
      return "canceled";
    case ApiProviderStatus.waiting_results:
      return "waiting_results";
    case ApiProviderStatus.rejected:
      return "rejected";
    case ApiProviderStatus.kyc_required:
      return "kyc_required";
    case ApiProviderStatus.qes_required:
      return "qes_required";
    case ApiProviderStatus.process_finished:
      return "process_finished";
    default:
      return "PROVIDER_STATUS_UNSPECIFIED";
  }
}

/** Request message for the CreateKYC RPC. */
export interface ApiCreateKYCRequest {
  /** The ID of the stakeholder to initiate KYC for. */
  readonly stakeholderId: string;
  /**
   * Optional URI to redirect the user to after the IDNow flow ends.
   * IDNow will prefix this with a domain from configuration.
   */
  readonly redirectionUri?: string | null | undefined;
}

/**
 * Response message for the CreateKYC RPC.
 * The response shape depends on the KYC provider assigned to the stakeholder:
 * - For Fourthline: the backend returns a JSON:API envelope. The frontend must
 *   extract fields from `data.attributes` before calling `fromJSON()` on FourthlineProcess.
 * - For all other providers (idnow_videoident, onfido, qonto, inpi): the backend
 *   returns a standard REST response wrapped in a `kyc` key. Use KYCStatus directly.
 */
export interface ApiCreateKYCResponse {
  /** Provider-specific response payload. */
  readonly result:
    | //
    /**
     * KYC status for non-Fourthline providers (idnow_videoident, onfido, qonto, inpi).
     * Maps to the `kyc` key in the REST response.
     */
    { readonly $case: "kyc"; readonly value: ApiKYCStatus }
    | //
    /**
     * KYC process details for the Fourthline provider.
     * Maps to the `data.attributes` object in the JSON:API response.
     */
    { readonly $case: "fourthlineProcess"; readonly value: ApiFourthlineProcess }
    | null;
}

/**
 * KYC status returned for non-Fourthline providers.
 * Serialized by V1::KYCSerializer on the backend.
 */
export interface ApiKYCStatus {
  /** The ID of the stakeholder this KYC status belongs to. */
  readonly stakeholderId: string;
  /** The KYC provider handling the verification. */
  readonly provider: ApiProvider;
  /** The provider-assigned identifier for this KYC case. */
  readonly providerId: string;
  /** A token used to authenticate with the KYC provider's SDK. */
  readonly providerToken?:
    | string
    | null
    | undefined;
  /** The current status of the KYC verification process. */
  readonly providerStatus: ApiProviderStatus;
  /** URL to redirect the user to for completing KYC verification. */
  readonly redirectUrl?:
    | string
    | null
    | undefined;
  /**
   * Whether a Qualified Electronic Signature (QES) is required.
   * Currently only required for French customers.
   */
  readonly isQesRequired?:
    | boolean
    | null
    | undefined;
  /** The device type used for identification (e.g. WEB, APP). */
  readonly device?:
    | string
    | null
    | undefined;
  /** The reason for the current KYC status (provider-specific reason code). */
  readonly reason?: string | null | undefined;
}

/**
 * KYC process details returned for the Fourthline provider.
 * These fields correspond to the `attributes` object inside the JSON:API `data` envelope.
 * The frontend must extract from `data.attributes` before calling `fromJSON()`.
 */
export interface ApiFourthlineProcess {
  /** A token used to initialize the Fourthline WebSDK. */
  readonly providerToken: string;
  /** URL to show the QR code and send SMS (for web flows). */
  readonly redirectUrl: string;
  /** Whether a Qualified Electronic Signature (QES) is required. */
  readonly isQesRequired: boolean;
}

export const ApiCreateKYCRequest: MessageFns<ApiCreateKYCRequest> = {
  fromJSON(object: any): ApiCreateKYCRequest {
    return {
      stakeholderId: isSet(object.stakeholder_id) ? globalThis.String(object.stakeholder_id) : "",
      redirectionUri: isSet(object.redirection_uri) ? globalThis.String(object.redirection_uri) : null,
    };
  },

  toJSON(message: ApiCreateKYCRequest): unknown {
    const obj: any = {};
    if (message.stakeholderId !== undefined && message.stakeholderId !== null) {
      obj.stakeholder_id = message.stakeholderId;
    }
    if (message.redirectionUri !== undefined && message.redirectionUri !== null) {
      obj.redirection_uri = message.redirectionUri;
    }
    return obj;
  },
};

export const ApiCreateKYCResponse: MessageFns<ApiCreateKYCResponse> = {
  fromJSON(object: any): ApiCreateKYCResponse {
    return {
      result: isSet(object.kyc)
        ? { $case: "kyc", value: ApiKYCStatus.fromJSON(object.kyc) }
        : isSet(object.fourthlineProcess)
        ? { $case: "fourthlineProcess", value: ApiFourthlineProcess.fromJSON(object.fourthlineProcess) }
        : isSet(object.fourthline_process)
        ? { $case: "fourthlineProcess", value: ApiFourthlineProcess.fromJSON(object.fourthline_process) }
        : null,
    };
  },

  toJSON(message: ApiCreateKYCResponse): unknown {
    const obj: any = {};
    if (message.result?.$case === "kyc") {
      obj.kyc = ApiKYCStatus.toJSON(message.result.value);
    } else if (message.result?.$case === "fourthlineProcess") {
      obj.fourthlineProcess = ApiFourthlineProcess.toJSON(message.result.value);
    }
    return obj;
  },
};

export const ApiKYCStatus: MessageFns<ApiKYCStatus> = {
  fromJSON(object: any): ApiKYCStatus {
    return {
      stakeholderId: isSet(object.stakeholder_id) ? globalThis.String(object.stakeholder_id) : "",
      provider: isSet(object.provider) ? apiProviderFromJSON(object.provider) : ApiProvider.PROVIDER_UNSPECIFIED,
      providerId: isSet(object.provider_id) ? globalThis.String(object.provider_id) : "",
      providerToken: isSet(object.provider_token) ? globalThis.String(object.provider_token) : null,
      providerStatus: isSet(object.provider_status)
        ? apiProviderStatusFromJSON(object.provider_status)
        : ApiProviderStatus.PROVIDER_STATUS_UNSPECIFIED,
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : null,
      isQesRequired: isSet(object.is_qes_required) ? globalThis.Boolean(object.is_qes_required) : null,
      device: isSet(object.device) ? globalThis.String(object.device) : null,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : null,
    };
  },

  toJSON(message: ApiKYCStatus): unknown {
    const obj: any = {};
    if (message.stakeholderId !== undefined && message.stakeholderId !== null) {
      obj.stakeholder_id = message.stakeholderId;
    }
    if (message.provider !== undefined && message.provider !== null) {
      obj.provider = apiProviderToJSON(message.provider);
    }
    if (message.providerId !== undefined && message.providerId !== null) {
      obj.provider_id = message.providerId;
    }
    if (message.providerToken !== undefined && message.providerToken !== null) {
      obj.provider_token = message.providerToken;
    }
    if (message.providerStatus !== undefined && message.providerStatus !== null) {
      obj.provider_status = apiProviderStatusToJSON(message.providerStatus);
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.isQesRequired !== undefined && message.isQesRequired !== null) {
      obj.is_qes_required = message.isQesRequired;
    }
    if (message.device !== undefined && message.device !== null) {
      obj.device = message.device;
    }
    if (message.reason !== undefined && message.reason !== null) {
      obj.reason = message.reason;
    }
    return obj;
  },
};

export const ApiFourthlineProcess: MessageFns<ApiFourthlineProcess> = {
  fromJSON(object: any): ApiFourthlineProcess {
    return {
      providerToken: isSet(object.provider_token) ? globalThis.String(object.provider_token) : "",
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "",
      isQesRequired: isSet(object.is_qes_required) ? globalThis.Boolean(object.is_qes_required) : false,
    };
  },

  toJSON(message: ApiFourthlineProcess): unknown {
    const obj: any = {};
    if (message.providerToken !== undefined && message.providerToken !== null) {
      obj.provider_token = message.providerToken;
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    if (message.isQesRequired !== undefined && message.isQesRequired !== null) {
      obj.is_qes_required = message.isQesRequired;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
